import { render, staticRenderFns } from "./ProductionManagement.vue?vue&type=template&id=50955d3d&lang=pug&"
import script from "./ProductionManagement.vue?vue&type=script&lang=js&"
export * from "./ProductionManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports